"use client";
import React, { useState } from "react";
import { projects, projects_other, Quality, workText } from "../../../data";
import ProjectGrid from "../../components/work/ProjectGrid";
import { useEventListener } from "usehooks-ts";
import useBlobity from "../../components/shared/blobity/useBlobity";
import Blur from "../../components/shared/overlay/Blur";
import Color from "../../components/shared/overlay/Color";
import HeroWork from "@/components/pages/Projects/sections/HeroWork";
import NavBarWork from "@/components/pages/Projects/sections/NavBarWork";
import { Toaster } from "@/components/ui/toaster";
import posthog from "posthog-js";

function page() {
  const [, setIsMobile] = useState(false); //isMobile
  const [showHidden, setShowHidden] = useState(false);

  useEventListener("resize", () => {
    setIsMobile(window.innerWidth < 768);
  });

  useBlobity({
    licenseKey: "opensource",
    focusableElementsOffsetX: 4,
    focusableElementsOffsetY: 4,
    color: "#ffffff",
    dotColor: "#ffffff",
    invert: true,
    focusableElements:
      "[data-blobity], a:not([data-no-blobity]), li:not([data-no-blobity]), button:not([data-no-blobity]), [data-blobity-tooltip]",
    font: "'Inter', sans-serif",
    fontSize: 16,
    fontWeight: 900,
    opacity: 1.0,
    fontColor: "#ffffff",
    zIndex: 35,
    size: 50,
    radius: 5,
    magnetic: false,
  });

  return (
    <>
      <Blur />
      <Color />
      {/* <NavBarWork /> */}
      <main className="flex flex-col items-center justify-center bg-black">
        <HeroWork />

        <section className="relative z-10 flex w-full flex-col items-center justify-center bg-[#0E1016] bg-cover bg-center py-16 md:py-20 lg:py-20">
          <div id="picked">
            <h2 className="mb-4 text-left text-[30px] font-bold uppercase leading-[0.9em] tracking-tighter text-[#e4ded7] sm:text-[35px] md:mb-8 md:text-[45px] lg:text-[60px]">
              Výběr
            </h2>
          </div>
          <ProjectGrid projects={projects} />
          <div id="other">
            <h2 className="mb-4 mt-32 text-left text-[30px] font-bold uppercase leading-[0.9em] tracking-tighter text-[#e4ded7] sm:text-[35px] md:mb-8 md:text-[45px] lg:text-[60px]">
              Ostatní
            </h2>
          </div>
          <ProjectGrid
            projects={projects_other.filter(
              (project) => project.quality !== Quality.Hide
            )}
          />
          {!showHidden && (
            <div className="mt-5">
              <button
                onClick={() => {
                  setShowHidden(true);
                  posthog.capture("project_showmore", { depth: 2 });
                }}
                className="text-[#e4ded7]"
              >
                {workText.more}
              </button>
            </div>
          )}
          {showHidden && (
            <ProjectGrid
              className="mt-10"
              projects={projects_other.filter(
                (project) => project.quality === Quality.Hide
              )}
            />
          )}
        </section>
      </main>
      <Toaster />
    </>
  );
}

export default page;
